const formGenerateEnquiry = document.getElementById("propSearchGenerateEnquiry");

if (formGenerateEnquiry) {
    formGenerateEnquiry.addEventListener("blur", event => {
        // event.preventDefault();

        // if (!document.getElementById("SaveTypeTemp")) {
        //     let el = document.createElement("input");
        //     el.type = "hidden";
        //     el.name = "save";
        //     el.value = "Save";
        //     el.id = "SaveTypeTemp";
        //     formGenerateEnquiry.appendChild(el);
        // }

        // setTimeout(function() {
        $.ajax({
            url: window.location.href,
            method: "POST",
            data: $('#propSearchGenerateEnquiry').serialize() + "&save=Save",
            success: function(data) {
                $("#enquiryPropRow").html($(data).find("#enquiryPropRow").html());
            },
            // complete: function(data) {
            //     document.getElementById("SaveTypeTemp").remove();
            // }
        });
        // }, 3000);

    }, true);
}

document.addEventListener("submit", event => {
    if (event.target.id == "propSearchGenerateEnquiryAdd") {
        event.preventDefault();
        var target = "#prop-wrap";
        let urlBuilder = window.location.href;

        if (urlBuilder.substring(urlBuilder.length - 1) == "#") {
            urlBuilder = urlBuilder.substring(0, urlBuilder.length - 1);
        }

        if (document.getElementById("propSearchKeyword").value) {
            let filterKeyword = document.getElementById("propSearchKeyword").value;
            filterKeyword = filterKeyword.replace(/ /g, "+");
            urlBuilder += "&k=" + filterKeyword;
        }

        console.log(urlBuilder);

        $.ajax({
            url: urlBuilder,
            beforeSend: function() {
                document.getElementById("propSearchGenerateEnquirySubmit").classList.add("prop-nav-site-search__submit-is-loading");
            },
            success: function(data) {
                document.getElementById("propSearchGenerateEnquirySubmit").classList.remove("prop-nav-site-search__submit-is-loading");
                $(target).html($(data).find(target).html());

            }
        });
    }
});

jQuery(document).on("click", "[data-prop-action]", function(event) {

    let propAction = this.dataset.propAction;
    let propId = this.dataset.propId;
    let enquiryId = this.dataset.enquiryId;
    let permission = true;

    if (propAction === "addToEnquiry" || propAction === "removeFromEnquiry") {
        event.preventDefault();

        if (propAction === "addToEnquiry") {
            this.innerHTML = `<span class="text-success">Added</span>`;
        } else if (propAction === "removeFromEnquiry") {
            permission = confirm("Want to delete?");
        }

        if (permission) {
            $.ajax({
                url: window.location.href,
                method: "POST",
                data: {
                    update: propAction,
                    pid: propId,
                    enquiryId: enquiryId,
                },
                success: function(data) {
                    $("#enquiryPropRow").html($(data).find("#enquiryPropRow").html());
                }
            });
        }

    }
});

// jQuery(document).on("click", "[data-prop-action]", function(event) {
//     let propAction = this.dataset.propAction;
//     let propID = this.dataset.propId;



//     if (propAction === "addToEnquiry") {
//         event.preventDefault();

//         var request = new XMLHttpRequest();

//         request.onload = function() {

//             // Begin accessing JSON data here
//             var data = JSON.parse(this.response);

//             if (request.status >= 200 && request.status < 400) {
//                 if ("content" in document.createElement("template")) {

//                     var template = document.getElementById("templateEnquiryPropColumn");

//                     var propRow = document.getElementById("enquiryPropRow");

//                     let iwh = data.width && data.height ? " x " : "";
//                     let iwd = data.height && data.depth ? " x " : "";
//                     let dimentions = data.width + iwh + data.height + iwd + data.depth;

//                     let randNum = Math.floor((Math.random() * 1000) + 1);

//                     // Clone the new row and insert it into the table
//                     var clone = document.importNode(template.content, true);
//                     clone.querySelectorAll("img")[0].src = data.imgURL;
//                     clone.querySelectorAll("span")[0].innerHTML = data.refNo;
//                     clone.querySelectorAll("span")[1].innerHTML = data.title;
//                     clone.querySelectorAll("span")[2].innerHTML = dimentions;
//                     clone.querySelectorAll("input")[2].value = data.imgURL;
//                     clone.querySelectorAll("input")[3].value = data.refNo;
//                     clone.querySelectorAll("input")[4].value = data.title;
//                     clone.querySelectorAll("input")[5].value = data.height;
//                     clone.querySelectorAll("input")[6].value = data.width;
//                     clone.querySelectorAll("input")[7].value = data.depth;
//                     clone.querySelectorAll("label")[0].htmlFor = "inputQty" + randNum;
//                     clone.querySelectorAll("input")[9].id = "inputQty" + randNum;
//                     clone.querySelectorAll("input")[9].placeholder = 1;
//                     clone.querySelectorAll("input")[9].value = 1;
//                     clone.querySelectorAll("label")[1].htmlFor = "inputPrice" + randNum;
//                     clone.querySelectorAll("input")[10].id = "inputPrice" + randNum;
//                     clone.querySelectorAll("input")[10].placeholder = data.price;
//                     clone.querySelectorAll("input")[10].value = data.price;


//                     propRow.appendChild(clone);

//                 } else {
//                     alert("your browser doesn't support this yet, use another one");
//                 }


//             } else {
//                 console.log("error getting api");
//             }
//         };
//         request.open("GET", "http://" + window.location.hostname + "/wp-json/themetraders/v1/prop/id/" + propID, true);
//         request.send();



//     } else if (propAction === "removeFromEnquiry") {
//         event.preventDefault();
//         event.target.parentNode.parentNode.remove();
//     }

// });

// window.addEventListener("beforeunload", (event) => {
//     // Cancel the event as stated by the standard.
//     event.preventDefault();
//     // Chrome requires returnValue to be set.
//     event.returnValue = "";
// });